import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { SupportedLanguage } from '../../types/i18n';
import { translations } from '../../constants/langs';

interface UseTranslationReturn {
    t: (key: string, params?: Record<string, string>) => string;
    language: SupportedLanguage;
}


export const useTranslation = (): UseTranslationReturn => {
    const { lang } = useParams<{ lang: string }>();

    const currentLanguage = useMemo((): SupportedLanguage => {
        if (lang === 'sp' || lang === 'en') {
            return lang;
        }
        return 'en'; // default fallback
    }, [lang]);

    const t = useMemo(() => {
        return (key: string, params?: Record<string, string>): string => {
            const keys = key.split('.');
            let value: any = translations[currentLanguage];

            for (const k of keys) {
                value = value?.[k];
            }

            if (typeof value !== 'string') {
                // Fallback to English if translation not found
                let fallback: any = translations.en;
                for (const k of keys) {
                    fallback = fallback?.[k];
                }
                value = typeof fallback === 'string' ? fallback : key;
            }

            // Replace parameters in the string
            if (params && typeof value === 'string') {
                return Object.entries(params).reduce((str, [paramKey, paramValue]) => {
                    return str.replace(new RegExp(`{{${paramKey}}}`, 'g'), paramValue);
                }, value);
            }

            return value;
        };
    }, [currentLanguage]);

    console.log(currentLanguage, "lang");


    return { t, language: currentLanguage };
};
